import { RootPaths } from "@src/appV2/App/paths";

export const SHIFT_DISCOVERY_PATH = "shift-discovery";

export const WORK_WITH_FRIENDS_PATH = "account/friends";

export const SHIFT_DISCOVERY_LIST_PATH = `shift-discovery/list`;
export const SHIFT_DISCOVERY_MAP_PATH = `shift-discovery/map`;
export const SHIFT_DISCOVERY_HELLO_SIGN_PATH = `shift-discovery/hello-sign`;

export const SHIFT_DISCOVERY_CALENDAR_PATH = `calendar`;
export const SHIFT_DISCOVERY_FILTERS_PATH = `filters`;
export const SHIFT_DISCOVERY_RECOMMENDED_PATH = `recommended`;
export const SHIFT_DISCOVERY_ENABLE_LOCATION_PERMISSIONS_PATH = `location-permissions`;
export const SHIFT_DISCOVERY_BASKET_SIZE_WILL_REACH_WARNING_MODAL_PATH =
  "basket-size-will-reach-warning";
export const SHIFT_DISCOVERY_URGENT_PATH = `urgent`;
export const SHIFT_DISCOVERY_HOME_HEALTH_PATH = `home-health`;
export const SHIFT_DISCOVERY_IN_HOME_PATH = `in-home`;
export const SHIFT_DISCOVERY_BLOCKS_PATH = `blocks`;
export const SHIFT_DISCOVERY_ORIENTATION_BLOCKS_PATH = `blocks/orientation/:facilityId`;
export const SHIFT_DISCOVERY_TRAVEL_BLOCKS_PATH = `travel-blocks`;
export const SHIFT_DISCOVERY_PRIORITY_PATH = `priority`;
export const SHIFT_DISCOVERY_TIER_PATH = `tier`;
export const SHIFT_DISCOVERY_FAVORITE_WORKPLACES_PATH = `favorite-workplaces`;
export const SHIFT_TRANSFER_PATH = `shift-transfer`;

/**
 * The modal system consists of two main types of modals:
 * 1. Workplace Modals - For displaying workplace related information
 * 2. Shift Modals - For displaying shift related information
 *
 * These modals can be rendered in different contexts:
 * - From the list view (/shift-discovery/list/...)
 * - From the map view (/shift-discovery/map/...)
 * - On top of other modals (nested modals)
 *
 * The path structure reflects this hierarchy:
 * Base path: /shift-discovery
 * Context path: /list or /map
 * Modal paths: /workplace/:id/... or /shift/:id/...
 *
 * Examples of complete paths:
 * 1. Workplace modal from map: /shift-discovery/map/workplace/123/profile
 * 2. Shift modal on top of workplace: /shift-discovery/list/workplace/123/open-shifts/shift/456
 * 3. Direct shift modal from list: /shift-discovery/list/shift/456
 */
export const SHIFT_DISCOVERY_SHIFT_MODAL_PATH = `shift/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_BOOKED_MODAL_PATH = `shift-booked/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_EDUCATE_NEW_WORKER_MODAL_PATH = `shift-educate-new-worker/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_EDUCATE_ABOUT_CLIPBOARD_SCORE_MODAL_PATH = `shift-educate-clipboard-score/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_ARRIVAL_TIME_MODAL_PATH = `shift-arrival-time/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_CONFIRM_BOOKING_MODAL_PATH = `shift-confirm-booking/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_BREAK_MODAL_PATH = `shift-break/:shiftId/note/:noteId`;
export const SHIFT_DISCOVERY_SHIFT_HELLO_SIGN_CONTAINER_MODAL_PATH = `shift-booking/:shiftId/document-submission/hello-sign/:requirementId`;
export const SHIFT_DISCOVERY_SHIFT_DOCUMENT_SUBMITTED_MODAL_PATH = `shift-booking/:shiftId/document-submitted/:requirementId/:documentStatus`;
export const SHIFT_DISCOVERY_SHIFT_AUCTION_PLACE_BID_MODAL_PATH = `shift-auction-place-bid/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_AUCTION_REVIEW_BID_MODAL_PATH = `shift-auction-review-bid/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_NEGOTIATION_MODAL_PATH = `shift-negotiation/:shiftId`;
export const SHIFT_DISCOVERY_SHIFT_NEGOTIATION_CANCEL_MODAL_PATH = `shift-negotiation-cancel/:shiftId`;

export const SHIFT_DISCOVERY_IN_APP_AD_MODAL_PATH = `in-app-ad/:adId`;

export const SHIFT_DISCOVERY_WORKPLACE_PROFILE_MODAL_PATH = `workplace/:workplaceId/profile`;
export const SHIFT_DISCOVERY_WORKPLACE_OPEN_SHIFTS_MODAL_PATH = `workplace/:workplaceId/open-shifts`;
export const SHIFT_DISCOVERY_WORKPLACE_POLICIES_MODAL_PATH = `workplace/:workplaceId/policies`;
export const SHIFT_DISCOVERY_WORKPLACE_CHECK_IN_MODAL_PATH = `workplace/:workplaceId/check-in`;
export const SHIFT_DISCOVERY_WORKPLACE_REVIEWS_MODAL_PATH = `workplace/:workplaceId/reviews`;
export const SHIFT_DISCOVERY_WORKPLACE_REVIEWS_COMMENT_MODAL_PATH = `workplace/:workplaceId/comment/:commentId`;
export const SHIFT_DISCOVERY_WORKPLACE_LEAVE_REVIEW_MODAL_PATH = `workplace/:workplaceId/reviews/leave-review`;
export const SHIFT_DISCOVERY_WORKPLACE_CLOCK_IN_GUIDE_MODAL_PATH = `workplace/:workplaceId/clock-in-guide`;

export const SHIFT_DISCOVERY_WORKPLACES_LIST_MODAL_PATH = `workplaces-list`;

export const SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH = `case/:caseId/visit/:visitId`;
export const SHIFT_DISCOVERY_IN_HOME_VISIT_CONFIRM_BOOKING_MODAL_PATH = `case/:caseId/visit-confirm-booking/:visitId`;
export const SHIFT_DISCOVERY_IN_HOME_VISIT_BOOKED_MODAL_PATH = `case/:caseId/visit-booked/:visitId`;
export const SHIFT_DISCOVERY_IN_HOME_COMMS_BANNER_PATH = `comms-banner`;

export const WORK_WITH_FRIENDS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${WORK_WITH_FRIENDS_PATH}`;
export const SHIFT_DISCOVERY_SHIFT_MODAL_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_SHIFT_MODAL_PATH}`;
export const SHIFT_DISCOVERY_SHIFT_CONFIRM_BOOKING_MODAL_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_SHIFT_CONFIRM_BOOKING_MODAL_PATH}`;
export const SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_WORKPLACE_PROFILE_MODAL_PATH}`;
export const SHIFT_DISCOVERY_WORKPLACE_POLICIES_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_WORKPLACE_POLICIES_MODAL_PATH}`;
export const SHIFT_DISCOVERY_WORKPLACE_CLOCK_IN_GUIDE_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_WORKPLACE_CLOCK_IN_GUIDE_MODAL_PATH}`;
export const SHIFT_DISCOVERY_FAVORITE_WORKPLACES_FULL_PATH = `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_FAVORITE_WORKPLACES_PATH}`;
